const productReviews = (() => {
  const EL_SECTION = '[data-reviews-section]';
  const EL_COUNT = '[data-reviews-count]';
  const EL_AVERAGE = '[data-reviews-average]';
  const EL_AVERAGE_STARS = '[data-reviews-average-stars]';
  const EL_STARS = '[data-reviews-stars]';
  const EL_FEATURED = '[data-featured-reviews]';
  const EL_REVIEWS = '[data-reviews-reviews]';
  const EL_MORE = '[data-reviews-more]';

  let instances = {};

  let reviewsPerPage = 2;
  let baseURL = 'https://api.juniphq.com';
  let requestOptions = {
    method: "GET",
    headers: {
      "Junip-Store-Key": 'Y4ZSYzPdCsFffd1QBz2mhRMa',
    },
    redirect: "follow",
  };

  async function fetchOverview(instance) {
    const { product } = instance;
    let url = `${baseURL}/v1/${product ? `products?filter[remote_ids]=${product}` : 'stores/12051'}`;

    const response = await fetch(url, requestOptions);
    const data = await response.json();
    return product ? data.products[0] : data.store;
  }

  async function fetchReviews(instance) {
    const { product, page, hasFeatured } = instance;
    let url = !hasFeatured ? `${baseURL}/v1/${product ? `product_reviews?filter[product_remote_ids]=${product}&` : 'store_reviews?'}include=customer,attribute_records${page.nextCursor ? `&page[after]=${page.nextCursor}` : ""}` : `${window.location.href}#featured-reviews-data-${instance.id}`;

    const response = await fetch(url, requestOptions);
    const data = hasFeatured ? await response.text() : await response.json();
    return data;
  }

  function createStars(elStars, index) {
    const rating = Number(elStars.getAttribute('data-reviews-stars'));
    const percent = (rating / 5) * 100;

    elStars.innerHTML = `
      <svg width="138" height="21" viewBox="0 0 138 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask${index}" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="138" height="21">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M49.9276 7.63125C49.8337 7.33592 49.6528 7.07585 49.4086 6.88513C49.1643 6.69441 48.8681 6.58195 48.5588 6.5625L42.9901 6.17813L40.9276 0.975C40.815 0.688503 40.6189 0.44241 40.3649 0.268579C40.1108 0.0947477 39.8104 0.00118395 39.5026 0V0C39.1948 0.00118395 38.8944 0.0947477 38.6403 0.268579C38.3862 0.44241 38.1902 0.688503 38.0776 0.975L35.9776 6.20625L30.4463 6.5625C30.1374 6.58321 29.8419 6.69614 29.5978 6.88668C29.3538 7.07722 29.1726 7.33659 29.0776 7.63125C28.98 7.93043 28.9743 8.25197 29.0612 8.55442C29.1481 8.85686 29.3236 9.12635 29.5651 9.32812L33.8213 12.9281L32.5557 17.9062C32.4682 18.243 32.4839 18.5983 32.6009 18.926C32.718 19.2537 32.9309 19.5386 33.212 19.7438C33.4848 19.9396 33.8099 20.0495 34.1456 20.0596C34.4813 20.0696 34.8123 19.9792 35.0963 19.8L39.4932 17.0156H39.512L44.2463 20.0062C44.4892 20.1641 44.7723 20.2487 45.062 20.25C45.2985 20.2481 45.5314 20.1921 45.7428 20.0861C45.9542 19.9802 46.1386 19.8272 46.2816 19.6389C46.4247 19.4505 46.5226 19.2319 46.568 18.9998C46.6133 18.7677 46.6049 18.5283 46.5432 18.3L45.2026 12.8531L49.4401 9.32812C49.6816 9.12635 49.8571 8.85686 49.944 8.55442C50.0309 8.25197 50.0252 7.93043 49.9276 7.63125Z" fill="white"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M78.9276 7.63125C78.8337 7.33592 78.6528 7.07585 78.4086 6.88513C78.1643 6.69441 77.8681 6.58195 77.5588 6.5625L71.9901 6.17813L69.9276 0.975C69.815 0.688503 69.6189 0.44241 69.3649 0.268579C69.1108 0.0947477 68.8104 0.00118395 68.5026 0V0C68.1948 0.00118395 67.8944 0.0947477 67.6403 0.268579C67.3862 0.44241 67.1902 0.688503 67.0776 0.975L64.9776 6.20625L59.4463 6.5625C59.1374 6.58321 58.8419 6.69614 58.5978 6.88668C58.3538 7.07722 58.1726 7.33659 58.0776 7.63125C57.98 7.93043 57.9743 8.25197 58.0612 8.55442C58.1481 8.85686 58.3236 9.12635 58.5651 9.32812L62.8213 12.9281L61.5557 17.9062C61.4682 18.243 61.4839 18.5983 61.6009 18.926C61.718 19.2537 61.9309 19.5386 62.212 19.7438C62.4848 19.9396 62.8099 20.0495 63.1456 20.0596C63.4813 20.0696 63.8123 19.9792 64.0963 19.8L68.4932 17.0156H68.512L73.2463 20.0062C73.4892 20.1641 73.7723 20.2487 74.062 20.25C74.2985 20.2481 74.5314 20.1921 74.7428 20.0861C74.9542 19.9802 75.1386 19.8272 75.2816 19.6389C75.4247 19.4505 75.5226 19.2319 75.568 18.9998C75.6133 18.7677 75.6049 18.5283 75.5432 18.3L74.2026 12.8531L78.4401 9.32812C78.6816 9.12635 78.8571 8.85686 78.944 8.55442C79.0309 8.25197 79.0252 7.93043 78.9276 7.63125Z" fill="white"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M107.928 7.63125C107.834 7.33592 107.653 7.07585 107.409 6.88513C107.164 6.69441 106.868 6.58195 106.559 6.5625L100.99 6.17813L98.9276 0.975C98.815 0.688503 98.6189 0.44241 98.3649 0.268579C98.1108 0.0947477 97.8104 0.00118395 97.5026 0V0C97.1948 0.00118395 96.8944 0.0947477 96.6403 0.268579C96.3862 0.44241 96.1902 0.688503 96.0776 0.975L93.9776 6.20625L88.4463 6.5625C88.1374 6.58321 87.8419 6.69614 87.5978 6.88668C87.3538 7.07722 87.1726 7.33659 87.0776 7.63125C86.98 7.93043 86.9743 8.25197 87.0612 8.55442C87.1481 8.85686 87.3236 9.12635 87.5651 9.32812L91.8213 12.9281L90.5557 17.9062C90.4682 18.243 90.4839 18.5983 90.6009 18.926C90.718 19.2537 90.9309 19.5386 91.212 19.7438C91.4848 19.9396 91.8099 20.0495 92.1456 20.0596C92.4813 20.0696 92.8123 19.9792 93.0963 19.8L97.4932 17.0156H97.512L102.246 20.0062C102.489 20.1641 102.772 20.2487 103.062 20.25C103.298 20.2481 103.531 20.1921 103.743 20.0861C103.954 19.9802 104.139 19.8272 104.282 19.6389C104.425 19.4505 104.523 19.2319 104.568 18.9998C104.613 18.7677 104.605 18.5283 104.543 18.3L103.203 12.8531L107.44 9.32812C107.682 9.12635 107.857 8.85686 107.944 8.55442C108.031 8.25197 108.025 7.93043 107.928 7.63125Z" fill="white"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M136.928 7.63125C136.834 7.33592 136.653 7.07585 136.409 6.88513C136.164 6.69441 135.868 6.58195 135.559 6.5625L129.99 6.17813L127.928 0.975C127.815 0.688503 127.619 0.44241 127.365 0.268579C127.111 0.0947477 126.81 0.00118395 126.503 0V0C126.195 0.00118395 125.894 0.0947477 125.64 0.268579C125.386 0.44241 125.19 0.688503 125.078 0.975L122.978 6.20625L117.446 6.5625C117.137 6.58321 116.842 6.69614 116.598 6.88668C116.354 7.07722 116.173 7.33659 116.078 7.63125C115.98 7.93043 115.974 8.25197 116.061 8.55442C116.148 8.85686 116.324 9.12635 116.565 9.32812L120.821 12.9281L119.556 17.9062C119.468 18.243 119.484 18.5983 119.601 18.926C119.718 19.2537 119.931 19.5386 120.212 19.7438C120.485 19.9396 120.81 20.0495 121.146 20.0596C121.481 20.0696 121.812 19.9792 122.096 19.8L126.493 17.0156H126.512L131.246 20.0062C131.489 20.1641 131.772 20.2487 132.062 20.25C132.298 20.2481 132.531 20.1921 132.743 20.0861C132.954 19.9802 133.139 19.8272 133.282 19.6389C133.425 19.4505 133.523 19.2319 133.568 18.9998C133.613 18.7677 133.605 18.5283 133.543 18.3L132.203 12.8531L136.44 9.32812C136.682 9.12635 136.857 8.85686 136.944 8.55442C137.031 8.25197 137.025 7.93043 136.928 7.63125Z" fill="white"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M20.9276 7.63125C20.8337 7.33592 20.6528 7.07585 20.4086 6.88513C20.1643 6.69441 19.8681 6.58195 19.5588 6.5625L13.9901 6.17813L11.9276 0.975C11.815 0.688503 11.6189 0.44241 11.3649 0.268579C11.1108 0.0947477 10.8104 0.00118395 10.5026 0V0C10.1948 0.00118395 9.89437 0.0947477 9.64031 0.268579C9.38625 0.44241 9.19022 0.688503 9.0776 0.975L6.9776 6.20625L1.44635 6.5625C1.13745 6.58321 0.841867 6.69614 0.597848 6.88668C0.353828 7.07722 0.172596 7.33659 0.0775971 7.63125C-0.0199585 7.93043 -0.0256583 8.25197 0.0612326 8.55442C0.148124 8.85686 0.323621 9.12635 0.565097 9.32812L4.82135 12.9281L3.55572 17.9062C3.46816 18.243 3.48392 18.5983 3.60095 18.926C3.71798 19.2537 3.93088 19.5386 4.21197 19.7438C4.48481 19.9396 4.80988 20.0495 5.14557 20.0596C5.48126 20.0696 5.81231 19.9792 6.09635 19.8L10.4932 17.0156H10.512L15.2463 20.0062C15.4892 20.1641 15.7723 20.2487 16.062 20.25C16.2985 20.2481 16.5314 20.1921 16.7428 20.0861C16.9542 19.9802 17.1386 19.8272 17.2816 19.6389C17.4247 19.4505 17.5226 19.2319 17.568 18.9998C17.6133 18.7677 17.6049 18.5283 17.5432 18.3L16.2026 12.8531L20.4401 9.32812C20.6816 9.12635 20.8571 8.85686 20.944 8.55442C21.0309 8.25197 21.0252 7.93043 20.9276 7.63125Z" fill="white"/>
        </mask>
        <g mask="url(#mask${index})">
          <rect width="138" height="21" fill="url(#gradient${index})"/>
          <path d="M49.4511 7.78271L49.4522 7.78626C49.5188 7.99046 49.5227 8.20992 49.4634 8.41636C49.4041 8.62266 49.2845 8.80649 49.1198 8.94418C49.1197 8.94427 49.1196 8.94436 49.1195 8.94444L44.8828 12.4687L44.6423 12.6688L44.7171 12.9726L46.0577 18.4195L46.0576 18.4195L46.0605 18.4303C46.1022 18.5848 46.108 18.7469 46.0773 18.9039C46.0466 19.061 45.9803 19.209 45.8835 19.3364C45.7866 19.4639 45.6619 19.5674 45.5188 19.6391C45.3766 19.7104 45.2201 19.7483 45.0611 19.75C44.8685 19.7485 44.6803 19.692 44.5188 19.587L44.5188 19.587L44.5134 19.5835L39.779 16.5929L39.6567 16.5156H39.512H39.4932H39.3482L39.2257 16.5932L34.8296 19.3771C34.8295 19.3772 34.8294 19.3772 34.8293 19.3773C34.6295 19.5033 34.3966 19.5668 34.1605 19.5598C33.9249 19.5527 33.6968 19.4758 33.5051 19.3387C33.3059 19.1928 33.1549 18.9905 33.0718 18.7579C32.9885 18.5246 32.9773 18.2718 33.0396 18.0321L33.0403 18.0294L34.3059 13.0513L34.383 12.7483L34.1442 12.5464L29.888 8.94637L29.888 8.94636L29.8857 8.94444C29.7209 8.80672 29.6011 8.62279 29.5418 8.41636C29.4825 8.20992 29.4864 7.99046 29.553 7.78626L29.5535 7.78468C29.6178 7.58526 29.7404 7.40972 29.9056 7.28077C30.0705 7.15196 30.2703 7.07555 30.4792 7.06142C30.4794 7.06141 30.4796 7.06139 30.4798 7.06138L36.0097 6.70522L36.3242 6.68496L36.4416 6.39252L38.5416 1.16127L38.5416 1.16127L38.5429 1.15792C38.6189 0.964596 38.7512 0.798533 38.9227 0.681232C39.0936 0.564293 39.2955 0.501185 39.5026 0.500005C39.7097 0.501185 39.9116 0.564294 40.0825 0.681232C40.254 0.798533 40.3863 0.964596 40.4623 1.15792L40.4628 1.15925L42.5253 6.36238L42.6414 6.65524L42.9557 6.67694L48.5244 7.06132L48.5275 7.06151C48.7362 7.07464 48.936 7.15053 49.1008 7.27922C49.2657 7.40792 49.3877 7.58341 49.4511 7.78271Z" stroke="black" stroke-width="2"/>
          <path d="M78.4511 7.78271L78.4522 7.78626C78.5188 7.99046 78.5227 8.20992 78.4634 8.41636C78.4041 8.62266 78.2845 8.80649 78.1198 8.94418C78.1197 8.94427 78.1196 8.94436 78.1195 8.94444L73.8828 12.4687L73.6423 12.6688L73.7171 12.9726L75.0577 18.4195L75.0576 18.4195L75.0605 18.4303C75.1022 18.5848 75.108 18.7469 75.0773 18.9039C75.0466 19.061 74.9803 19.209 74.8835 19.3364C74.7866 19.4639 74.6619 19.5674 74.5188 19.6391C74.3766 19.7104 74.2201 19.7483 74.0611 19.75C73.8685 19.7485 73.6803 19.692 73.5188 19.587L73.5188 19.587L73.5134 19.5835L68.779 16.5929L68.6567 16.5156H68.512H68.4932H68.3482L68.2257 16.5932L63.8296 19.3771C63.8295 19.3772 63.8294 19.3772 63.8293 19.3773C63.6295 19.5033 63.3966 19.5668 63.1605 19.5598C62.9249 19.5527 62.6968 19.4758 62.5051 19.3387C62.3059 19.1928 62.1549 18.9905 62.0718 18.7579C61.9885 18.5246 61.9773 18.2718 62.0396 18.0321L62.0403 18.0294L63.3059 13.0513L63.383 12.7483L63.1442 12.5464L58.888 8.94637L58.888 8.94636L58.8857 8.94444C58.7209 8.80672 58.6011 8.62279 58.5418 8.41636C58.4825 8.20992 58.4864 7.99046 58.553 7.78626L58.5535 7.78468C58.6178 7.58526 58.7404 7.40972 58.9056 7.28077C59.0705 7.15196 59.2703 7.07555 59.4792 7.06142C59.4794 7.06141 59.4796 7.06139 59.4798 7.06138L65.0097 6.70522L65.3242 6.68496L65.4416 6.39252L67.5416 1.16127L67.5416 1.16127L67.5429 1.15792C67.6189 0.964596 67.7512 0.798533 67.9227 0.681232C68.0936 0.564293 68.2955 0.501185 68.5026 0.500005C68.7097 0.501185 68.9116 0.564294 69.0825 0.681232C69.254 0.798533 69.3863 0.964596 69.4623 1.15792L69.4628 1.15925L71.5253 6.36238L71.6414 6.65524L71.9557 6.67694L77.5244 7.06132L77.5275 7.06151C77.7362 7.07464 77.936 7.15053 78.1008 7.27922C78.2657 7.40792 78.3877 7.58341 78.4511 7.78271Z" stroke="black" stroke-width="2"/>
          <path d="M107.451 7.78271L107.452 7.78626C107.519 7.99046 107.523 8.20992 107.463 8.41636C107.404 8.62266 107.284 8.80649 107.12 8.94418C107.12 8.94427 107.12 8.94436 107.119 8.94444L102.883 12.4687L102.642 12.6688L102.717 12.9726L104.058 18.4195L104.058 18.4195L104.061 18.4303C104.102 18.5848 104.108 18.7469 104.077 18.9039C104.047 19.061 103.98 19.209 103.883 19.3364C103.787 19.4639 103.662 19.5674 103.519 19.6391C103.377 19.7104 103.22 19.7483 103.061 19.75C102.869 19.7485 102.68 19.692 102.519 19.587L102.519 19.587L102.513 19.5835L97.779 16.5929L97.6567 16.5156H97.512H97.4932H97.3482L97.2257 16.5932L92.8296 19.3771C92.8295 19.3772 92.8294 19.3772 92.8293 19.3773C92.6295 19.5033 92.3966 19.5668 92.1605 19.5598C91.9249 19.5527 91.6968 19.4758 91.5051 19.3387C91.3059 19.1928 91.1549 18.9905 91.0718 18.7579C90.9885 18.5246 90.9773 18.2718 91.0396 18.0321L91.0403 18.0294L92.3059 13.0513L92.383 12.7483L92.1442 12.5464L87.888 8.94637L87.888 8.94636L87.8857 8.94444C87.7209 8.80672 87.6011 8.62279 87.5418 8.41636C87.4825 8.20992 87.4864 7.99046 87.553 7.78626L87.5535 7.78468C87.6178 7.58526 87.7404 7.40972 87.9056 7.28077C88.0705 7.15196 88.2703 7.07555 88.4792 7.06142C88.4794 7.06141 88.4796 7.06139 88.4798 7.06138L94.0097 6.70522L94.3242 6.68496L94.4416 6.39252L96.5416 1.16127L96.5416 1.16127L96.5429 1.15792C96.6189 0.964596 96.7512 0.798533 96.9227 0.681232C97.0936 0.564293 97.2955 0.501185 97.5026 0.500005C97.7097 0.501185 97.9116 0.564294 98.0825 0.681232C98.254 0.798533 98.3863 0.964596 98.4623 1.15792L98.4628 1.15925L100.525 6.36238L100.641 6.65524L100.956 6.67694L106.524 7.06132L106.527 7.06151C106.736 7.07464 106.936 7.15053 107.101 7.27922C107.266 7.40792 107.388 7.58341 107.451 7.78271Z" stroke="black" stroke-width="2"/>
          <path d="M136.451 7.78271L136.452 7.78626C136.519 7.99046 136.523 8.20992 136.463 8.41636C136.404 8.62266 136.284 8.80649 136.12 8.94418C136.12 8.94427 136.12 8.94436 136.119 8.94444L131.883 12.4687L131.642 12.6688L131.717 12.9726L133.058 18.4195L133.058 18.4195L133.061 18.4303C133.102 18.5848 133.108 18.7469 133.077 18.9039C133.047 19.061 132.98 19.209 132.883 19.3364C132.787 19.4639 132.662 19.5674 132.519 19.6391C132.377 19.7104 132.22 19.7483 132.061 19.75C131.869 19.7485 131.68 19.692 131.519 19.587L131.519 19.587L131.513 19.5835L126.779 16.5929L126.657 16.5156H126.512H126.493H126.348L126.226 16.5932L121.83 19.3771C121.829 19.3772 121.829 19.3772 121.829 19.3773C121.629 19.5033 121.397 19.5668 121.16 19.5598C120.925 19.5527 120.697 19.4758 120.505 19.3387C120.306 19.1928 120.155 18.9905 120.072 18.7579C119.989 18.5246 119.977 18.2718 120.04 18.0321L120.04 18.0294L121.306 13.0513L121.383 12.7483L121.144 12.5464L116.888 8.94637L116.888 8.94636L116.886 8.94444C116.721 8.80672 116.601 8.62279 116.542 8.41636C116.482 8.20992 116.486 7.99046 116.553 7.78626L116.553 7.78468C116.618 7.58526 116.74 7.40972 116.906 7.28077C117.071 7.15196 117.27 7.07555 117.479 7.06142C117.479 7.06141 117.48 7.06139 117.48 7.06138L123.01 6.70522L123.324 6.68496L123.442 6.39252L125.542 1.16127L125.542 1.16127L125.543 1.15792C125.619 0.964596 125.751 0.798533 125.923 0.681232C126.094 0.564293 126.296 0.501185 126.503 0.500005C126.71 0.501185 126.912 0.564294 127.083 0.681232C127.254 0.798533 127.386 0.964596 127.462 1.15792L127.463 1.15925L129.525 6.36238L129.641 6.65524L129.956 6.67694L135.524 7.06132L135.527 7.06151C135.736 7.07464 135.936 7.15053 136.101 7.27922C136.266 7.40792 136.388 7.58341 136.451 7.78271Z" stroke="black" stroke-width="2"/>
          <path d="M20.4511 7.78271L20.4522 7.78626C20.5188 7.99046 20.5227 8.20992 20.4634 8.41636C20.4041 8.62266 20.2845 8.80649 20.1198 8.94418C20.1197 8.94427 20.1196 8.94436 20.1195 8.94444L15.8828 12.4687L15.6423 12.6688L15.7171 12.9726L17.0577 18.4195L17.0576 18.4195L17.0605 18.4303C17.1022 18.5848 17.108 18.7469 17.0773 18.9039C17.0466 19.061 16.9803 19.209 16.8835 19.3364C16.7866 19.4639 16.6619 19.5674 16.5188 19.6391C16.3766 19.7104 16.2201 19.7483 16.0611 19.75C15.8685 19.7485 15.6803 19.692 15.5188 19.587L15.5188 19.587L15.5134 19.5835L10.779 16.5929L10.6567 16.5156H10.512H10.4932H10.3482L10.2257 16.5932L5.82956 19.3771C5.82946 19.3772 5.82937 19.3772 5.82928 19.3773C5.62946 19.5033 5.39661 19.5668 5.16049 19.5598C4.92493 19.5527 4.69681 19.4758 4.50515 19.3387C4.30586 19.1928 4.1549 18.9905 4.07182 18.7579C3.98853 18.5246 3.97731 18.2718 4.03964 18.0321L4.04031 18.0294L5.30593 13.0513L5.38297 12.7483L5.14424 12.5464L0.887993 8.94637L0.887999 8.94636L0.885701 8.94444C0.720884 8.80672 0.6011 8.62279 0.541794 8.41636C0.482487 8.20992 0.486378 7.99046 0.552966 7.78626L0.553476 7.78468C0.617769 7.58526 0.74042 7.40972 0.905565 7.28077C1.07054 7.15196 1.27034 7.07555 1.47916 7.06142C1.47937 7.06141 1.47959 7.06139 1.4798 7.06138L7.00973 6.70522L7.32421 6.68496L7.44161 6.39252L9.54161 1.16127L9.54162 1.16127L9.54294 1.15792C9.61893 0.964596 9.75121 0.798533 9.92265 0.681232C10.0936 0.564293 10.2955 0.501185 10.5026 0.500005C10.7097 0.501185 10.9116 0.564294 11.0825 0.681232C11.254 0.798533 11.3863 0.964596 11.4623 1.15792L11.4628 1.15925L13.5253 6.36238L13.6414 6.65524L13.9557 6.67694L19.5244 7.06132L19.5275 7.06151C19.7362 7.07464 19.936 7.15053 20.1008 7.27922C20.2657 7.40792 20.3877 7.58341 20.4511 7.78271Z" stroke="black" stroke-width="2"/>
        </g>
        <defs>
          <linearGradient id="gradient${index}" x1="0" y1="9" x2="138" y2="9" gradientUnits="userSpaceOnUse">
            <stop offset="${percent}%" stop-color="currentColor"/>
            <stop offset="${percent}%" stop-color="transparent"/>
          </linearGradient>
        </defs>
      </svg>
    `
  }

  function createOverview(elSection) {
    const id = elSection.getAttribute('data-reviews-section');
    const elCount = elSection.querySelector(EL_COUNT);
    const elAverage = elSection.querySelector(EL_AVERAGE);
    const elAverageStars = elSection.querySelector(EL_AVERAGE_STARS);
    
    const { count, average } = instances[id];

    elCount.innerHTML = `${count} Review${count > 1 ? 's' : ''}`
    elAverage.innerHTML = average;
    elAverageStars.setAttribute('data-reviews-stars', average);

    Object.keys(instances[id].distribution).forEach(key => {
      const elBar = elSection.querySelector(`[data-reviews-bar="${key}"]`);
      const elCount = elSection.querySelector(`[data-reviews-bar-count="${key}"]`);
      const ratingCount = instances[id].distribution[key];
      const percent = (ratingCount / count) * 100;

      elBar.style.setProperty('--width', `${percent}%`);
      elCount.innerHTML = ratingCount;
    })
  }

  function formatDate(date) {
    const postedDate = new Date(date);
    const now = new Date();

    function dateDiffInDays(a, b) {
      const _MS_PER_DAY = 1000 * 60 * 60 * 24;
      // Discard the time and time-zone information.
      const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
      const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

      return Math.floor((utc2 - utc1) / _MS_PER_DAY);
    }

    let difference = dateDiffInDays(postedDate, now);

    if(difference == 0) {
      return 'Today'
    } else if (difference == 1) {
      return 'Yesterday'
    } else if (difference < 14) {
      return `${difference} days ago`
    } else if (difference < 30) {
      let numOfWeeks = Math.floor(difference / 7);
      return `${numOfWeeks} week${numOfWeeks > 1 ? 's' : ''} ago`
    } else if (difference < 365) {
      let numOfMonths = Math.floor(difference / 30);
      return `${numOfMonths} month${numOfMonths > 1 ? 's' : ''} ago`
    } else {
      let numOfYears = Math.floor(difference / 365);
      return `${numOfYears} year${numOfYears > 1 ? 's' : ''} ago`
    }
  }

  function createReviews(reviews) {
   return reviews.map(review => 
`
      <li class="product__reviews-review">
        <div class="product__reviews-review--author">
          <p>${review.customer.first_name} ${review.customer.last_name ? review.customer.last_name : ''}</p>
          ${review.verified_buyer ? `
            <div class="verified">
              <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.75 6.61682L7.08125 10.1168L5.25 8.36682" stroke="#221F1F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8 14.1168C11.3137 14.1168 14 11.4305 14 8.11682C14 4.80311 11.3137 2.11682 8 2.11682C4.68629 2.11682 2 4.80311 2 8.11682C2 11.4305 4.68629 14.1168 8 14.1168Z" stroke="#221F1F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>Verified Buyer</span>
            </div>
          ` : ''}
        </div>
        <div class="product__reviews-review--rating">
          <span class="product__reviews-stars" data-reviews-stars="${review.rating}"></span>
          <span class="product__reviews-review--date">${formatDate(review.created_at)}</span>
        </div>
        <h3 class="product__reviews-review--heading">
          ${review.title}
        </h3>
        <p class="product__reviews-review--body">
          ${review.body}
        </p>
        <div class="product__reviews-review--images">
        ${review.sm_img_1!="" && review.sm_img_1 != undefined && review.sm_img_1 != null?(
          `<button class="product__reviews-review_button-dialog" onclick="open_review_img(event)">${review.sm_img_1}
            <dialog class="product__reviews-review_dialog">
              <span class="dialog_close" onclick="closeReviewDialog(event)">CLOSE</span>
              <div class="product__reviews-review_dialog-header">
              </div>
              
              <div class="product__reviews-review_dialog-content">
                <div class="product__reviews-review_dialog-content_inner">
                 <div class="product__reviews-review--author">
                  <div>
                    <p>${review.customer.first_name} ${review.customer.last_name ? review.customer.last_name : ''}</p>
                    <span class="product__reviews-review--date">${formatDate(review.created_at)}</span></div>
                  ${review.verified_buyer ? `
                 <div class="verified">
                  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.75 6.61682L7.08125 10.1168L5.25 8.36682" stroke="#221F1F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8 14.1168C11.3137 14.1168 14 11.4305 14 8.11682C14 4.80311 11.3137 2.11682 8 2.11682C4.68629 2.11682 2 4.80311 2 8.11682C2 11.4305 4.68629 14.1168 8 14.1168Z" stroke="#221F1F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                <span>Verified Buyer</span>
            </div>
          ` : ''}
        </div>
        <div class="product__reviews-review--rating">
          <span class="product__reviews-stars" data-reviews-stars="${review.rating}"></span>
        </div>
        <h3 class="product__reviews-review--heading">
          ${review.title}
        </h3>
        <p class="product__reviews-review--body">
          ${review.body}
        </p>
              </div>
              <div class="dialog_image">${review.lg_img_1}</div>
          
              </div>
            </dialog>
          </button>`
        ):""}
          

        ${review.sm_img_2!=""&&review.sm_img_2!=undefined&&review.sm_img_2!= null?(
          `<button class="product__reviews-review_button-dialog" onclick="open_review_img(event)">${review.sm_img_2}
            <dialog class="product__reviews-review_dialog">
              <span class="dialog_close" onclick="closeReviewDialog(event)">CLOSE</span>
              <div class="product__reviews-review_dialog-header">
              </div>
              <div class="product__reviews-review_dialog-content">
                <div class="product__reviews-review_dialog-content_inner">
              
                 <div class="product__reviews-review--author">
                  <div>
                    <p>${review.customer.first_name} ${review.customer.last_name ? review.customer.last_name : ''}</p>
                    <span class="product__reviews-review--date">${formatDate(review.created_at)}</span></div>
                  ${review.verified_buyer ? `
                 <div class="verified">
                  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.75 6.61682L7.08125 10.1168L5.25 8.36682" stroke="#221F1F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8 14.1168C11.3137 14.1168 14 11.4305 14 8.11682C14 4.80311 11.3137 2.11682 8 2.11682C4.68629 2.11682 2 4.80311 2 8.11682C2 11.4305 4.68629 14.1168 8 14.1168Z" stroke="#221F1F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                <span>Verified Buyer</span>
            </div>
          ` : ''}
        </div>
        <div class="product__reviews-review--rating">
          <span class="product__reviews-stars" data-reviews-stars="${review.rating}"></span>
        </div>
        <h3 class="product__reviews-review--heading">
          ${review.title}
        </h3>
        <p class="product__reviews-review--body">
          ${review.body}
        </p>
              </div>
              <div class="dialog_image">${review.lg_img_2}</div>
              </div>
            </dialog>
          </button>`
        ):""}
        
        </div>
        <p class="product__reviews-review--small">
          Review left on ${review.target_title}
        </p>
      </li>
    `).join('')
  }

  function appendReviews(elSection) {
    const elReviews = elSection.querySelector(EL_REVIEWS);
    const elMore = elSection.querySelector(EL_MORE);
    
    const id = elSection.getAttribute('data-reviews-section');
    const { hasFeatured, page } = instances[id];
    const { nextCursor, total, current } = page;

    const showButton = hasFeatured ? true : nextCursor !== null && total > current;

    let currentReviewsPage = instances[id].reviews[instances[id].page.current];
    instances[id].currentReviews = instances[id].currentReviews ? [...instances[id].currentReviews, ...currentReviewsPage] : currentReviewsPage;

    elReviews.innerHTML = createReviews(instances[id].currentReviews);
    elMore.style.display = showButton ? 'block' : 'none';

    bind(elSection);
  }

  function paginateReviews(ev) {
    const elButton = ev.currentTarget;
    const elSection = elButton.closest(EL_SECTION);
    const id = elSection.getAttribute('data-reviews-section');

    instances[id].page.current = instances[id].page.current + 1;

    let { current, total, nextCursor } = instances[id].page
    let shouldSetReviews = current == total && nextCursor !== null;

    if(instances[id].hasFeatured) {
      instances[id].hasFeatured = false;
      setReviews(elSection);
    } else if(shouldSetReviews) {
      setReviews(elSection);
    } else {
      appendReviews(elSection);
    }
  }

  function setReviews(elSection) {
    const id = elSection.getAttribute('data-reviews-section');

    fetchReviews(instances[id])
      .then(data => {
        let reviewsData;

        if(instances[id].hasFeatured) {
          let html = document.createElement("html");
			    html.innerHTML = data;

          let elData = html.querySelector(EL_FEATURED);
          reviewsData = JSON.parse(elData.innerHTML);
        } else {
          reviewsData = data;
        }
        
        let reviewsArray = instances[id].hasFeatured ? 'featured_reviews' : instances[id].product ? 'product_reviews' : 'store_reviews'
        if (!reviewsData[reviewsArray].length) return;

        let reviews = [];
        while (reviewsData[reviewsArray].length) {
          reviews.push(reviewsData[reviewsArray].splice(0, reviewsPerPage));
        }

        instances[id].reviews = instances[id].reviews ? [...instances[id].reviews, ...reviews] : reviews;
        instances[id].page.total = Math.ceil(instances[id].reviews.length);
        instances[id].page.nextCursor = reviewsData.meta.page.after;
      })
      .then(() => {
        createOverview(elSection);
        appendReviews(elSection);
      })
      .then(() => {
        bind(elSection);
      })
  }

  function bind(elSection) {
    const elStars = elSection.querySelectorAll(EL_STARS);
    elStars.forEach((el, index) => {
      createStars(el, index);
    })
  }

  function init() {
    const elSections = document.querySelectorAll(EL_SECTION);
    elSections.forEach(el => {
      const id = el.getAttribute('data-reviews-section');
      const { product, featured } = el.dataset;

      instances[id] = {
        id: id,
        product: product ? product : null,
        hasFeatured: featured == 'true',
        page: {
          current: 0,
          total: 0,
          nextCursor: null
        },
        count: 0,
        average: 0,
        distribution: {},
        reviews: [],
        currentReviews: [],
      }

                console.log('instances[id]', instances[id])


      fetchOverview(instances[id])
        .then(data => {
          instances[id].count = data.rating_count;
          instances[id].average = data.rating_average.toFixed(1);
          instances[id].distribution = data.rating_distribution;
        })
        .then(() => {
          setReviews(el);
        })
        .then(() => {
          const elMore = el.querySelector(EL_MORE);
          elMore.addEventListener('click', paginateReviews);
        })
        .catch(err => {
          el.classList.add('has-error');
          console.warn(err);
        })
    })
  }

  return {
    init
  }
})();

document.addEventListener('DOMContentLoaded', () => {
  productReviews.init();
})